// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a757ee24","239":"efb56266","455":"99c6884f"}[chunkId] + ".chunk.js";
};